let braintree;
import('braintree-web').then(lib => (braintree = lib));

// FYI braintree-web gziped is -132.07 KB  :<

const createBraintreeRequest = data => ({
    endpoint: 'payment_methods/credit_cards',
    method: 'post',
    data: {
        amount: data.amount,
        creditCard: {
            number: data.cardNumber,
            expirationDate: data.expDate.split(' ').join(''),
            cvv: data.cvv
        }
    }
});

const requestBraintreePayment = data => {
    return braintree.client
        .create({
            authorization: data.clientToken
        })
        .then(clientInstance => {
            return clientInstance.request(createBraintreeRequest(data)).then(response => {
                if (
                    response == null ||
                    response.creditCards == null ||
                    !response.creditCards.length
                ) {
                    return Promise.reject();
                }

                const nonce = response.creditCards[0].nonce;

                return { ...data, nonce };
            });
        });
};

export default requestBraintreePayment;



// WEBPACK FOOTER //
// ./src/utils/donation/braintree.js